import React, { useState } from 'react';

const LabelPrinter = () => {
  const [Product_ID, setProduct_ID] = useState('');
  const [sku, setSku] = useState('');
  const brandName = "TJD - DharmApanah";

  // Fetch SKU from backend based on Product_ID
  const fetchSKU = async () => {
    if (!Product_ID) return;
    try {
      const response = await fetch(`https://st.tjdstore.in/api/getsku.php?Product_ID=${Product_ID}`);
      const data = await response.json();
      if (data.sku) {
        setSku(data.sku);
      } else {
        alert('SKU not found for the given Product_ID.');
      }
    } catch (error) {
      console.error('Error fetching SKU:', error);
      alert('Failed to fetch SKU.');
    }
  };

  // Print label with text only
  const printLabel = () => {
    const newWindow = window.open('', '_blank');
    const htmlContent = `
      <html>
        <head>
          <style>
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
            }
            .label {
              width: 50mm;
              height: 18mm;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border: 1px solid #000;
              overflow: hidden;
              margin-top: 14px;
              box-sizing: border-box;
              font-family: Verdana, Arial, Helvetica, sans-serif;
            }
            .brand-name {
              font-size: 10px;
              font-weight: bold;
              margin-bottom: 2px;
            }
            .sku-text {
              font-size: 10px;
              margin-bottom: 2px;
            }
            .note {
              font-size: 9px;
              font-weight: bold;
              color: red;
              text-transform: uppercase;
              text-align: center
            }
          </style>
        </head>
        <body>
          <div class="label">
            <div class="brand-name">${brandName}</div>
            <div class="sku-text">SKU: ${sku}</div>
            <div class="note">FOR GIFTING PURPOSE ONLY<br/>
NO EXCHANGE OR SIZE CHANGE</div>
          </div>
          <script>
            window.onload = function() {
              window.print();
              window.close();
            };
          </script>
        </body>
      </html>
    `;
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Label Printer (No Barcode)</h2>
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="Product_ID">Enter Product ID:</label>
        <input
          id="Product_ID"
          type="text"
          value={Product_ID}
          onChange={(e) => setProduct_ID(e.target.value)}
          placeholder="Type Product ID here"
          style={{ marginLeft: '10px', padding: '5px' }}
        />
        <button
          onClick={fetchSKU}
          disabled={!Product_ID}
          style={{ marginLeft: '10px', padding: '5px 10px', backgroundColor: 'orange', color: 'white', border: 'none' }}
        >
          Fetch SKU
        </button>
      </div>
      {sku && (
        <button
          onClick={printLabel}
          style={{ padding: '6px 12px', backgroundColor: 'green', color: 'white', border: 'none' }}
        >
          Print Label
        </button>
      )}
    </div>
  );
};

export default LabelPrinter;
